import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const BlogsEndpoint = {
  getBlogs: `/admin/blog/list`,
  getBlogbyId: `/admin/blog/details/`,
  addBlog: `/admin/blog/add/`,
  editBlog: `/admin/blog/edit/`,
  deleteBlog: `/admin/blog/delete/`,
  uploadImage: `/admin/blog/uploadImage`
};

export const getBlogs = (param = "") => {
  const url = getAPIUrl(BlogsEndpoint.getBlogs, param);
  return Get(HomePageService, url, true);
};

export const getBlogbyId = (param = "") => {
  const url = getAPIUrl(BlogsEndpoint.getBlogbyId, param);
  return Get(HomePageService, url, true);
};

export const addBlog = (data, param = "") => {
  const url = getAPIUrl(BlogsEndpoint.addBlog, param);
  return Post(HomePageService, url, data, true);
};

export const editBlog = (data, param = "") => {
  const url = getAPIUrl(BlogsEndpoint.editBlog, param);
  return Put(HomePageService, url, data, true);
};

export const deleteBlog = (param = "") => {
  const url = getAPIUrl(BlogsEndpoint.deleteBlog, param);
  return Delete(HomePageService, url, param);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(BlogsEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};